export const ACCOUNT_ENDPOINTS = {
  CHANGE_PASSWORD: '/newUsers/changePassword',
  UPDATE_LANGUAGE: '/newUsers/updateLanguage',
} as const;
